export default Object.freeze({
  Monthly: 1,
  Quarterly: 2,
  Annual: 3,
});
